export default __webpack_public_path__ + "static/media/new-delete-search-icon.eac34986.svg";